import { PATH_CALL_CENTER, PATH_CALL_CENTER_CALL_LEAD, PATH_CALL_CENTER_JOIN } from "@/routes/paths";
import { useLocation } from "react-router-dom";
import MainCallCenterTopHeader from "./cc-top-header/main.top.header.cc";
import MainTopBar from "./top-bar/main.top.bar";

// Agent in-call routes (video + voice) — join-meeting-as-admin keeps the
// header (its screen still uses the regular layout).
const IN_CALL_PREFIXES = [
  PATH_CALL_CENTER_JOIN.replace(":sessionName", ""),
  PATH_CALL_CENTER_CALL_LEAD.replace(":sessionName", ""),
];

const MainTopHeader: React.FC = () => {
  const location = useLocation();
  const isCallCenterPage = location.pathname.startsWith(PATH_CALL_CENTER);
  // The in-call screen is immersive (demo-ui session layout): no workspace
  // header, room selector or tabs while the agent is on a call. The layout
  // mounts CallCenterSelectionBootstrap to cover the header's data bootstrap.
  const isInCallPage = IN_CALL_PREFIXES.some((prefix) => location.pathname.startsWith(prefix));

  if (isInCallPage) return null;

  // Demo-ui Topbar (search palette, quick create, user chip) — desktop and
  // mobile, on every non-in-call route. Call-center pages stack their own
  // workspace header (room selector + tabs) below it.
  if (isCallCenterPage) {
    return (
      <>
        <MainTopBar />
        <MainCallCenterTopHeader />
      </>
    );
  }

  return <MainTopBar />;
};

export default MainTopHeader;
